import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './SampleModal.css'
import axios from 'axios';

import { ToastContainer, toast, cssTransition } from "react-toastify";
Modal.setAppElement('#root'); // Ensure accessibility

function SampleModal({ isOpen, onRequestClose, test, handleSampleReceivedStatus, readOnly }) {


  const [testList, setTestList] = useState([]);
  const [tat, setTat] = useState();
  
  useEffect(() => {
    const fetchtestlist = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/testlist`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`, // Ensure you're sending the token
          }
        });
       
        setTestList(response.data);
         
      } catch (error) {
        console.error('Failed to fetch sales entries:', error);
      }

    };

  fetchtestlist();
  },[]);


  


  const today = new Date();
  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

 
    // Helper function to format the current time as HH:MM
    const formatTimeToHHMM = (date) => {
      const hours = String(date.getHours()).padStart(2, "0"); // Get hours (0-23)
      const minutes = String(date.getMinutes()).padStart(2, "0"); // Get minutes (0-59)
  
      return `${hours}:${minutes}`;
    };


  const [sampleReceivedStatus, setSampleReceivedStatus] = useState(test.sampleReceivedStatus || "Pending");
  const [sampleReceivedDate, setSampleReceivedDate] = useState(() => {

    if (test.sampleReceivedDate) {
      return test.sampleReceivedDate; // Use the value from test if available
    }

    return formatDateToYYYYMMDD(today)// Default to current date
  });
  
 

  // const [sampleReceivedTime, setSampleReceivedTime] = useState(test.sampleReceivedTime || "");
  const [sampleReceivedTime, setSampleReceivedTime] = useState(() => {

    if (test.sampleReceivedTime) {
      return test.sampleReceivedTime; // Use the value from test if available
    }

    return formatTimeToHHMM(today)// Default to current date
  });
  const [rejectionReason, setRejectionReason] = useState(test.rejectionReason || "");
  
  // const [expectedReportDate,setExpectedReportDate]=useState(test.expectedReportDate||"");
  useEffect(() => {
    if (testList.length > 0 && test?.test) {
      const expectedDate = calculateExpectedReportDateBasedonTAT();
      setExpectedReportDate(expectedDate);
      console.log("insideuseeffect of testlist",expectedDate)
    }
  }, [testList, test,sampleReceivedStatus]); // Run only when `testList` or `test` changes.

  const calculateExpectedReportDateBasedonTAT = () => {
    console.log("inside calculateExpectedReportDateBasedonTAT")
    if (!test.sampleReceivedDate) {
    console.log("inside if statement of calculateExpectedReportDateBasedonTAT")
    // Find the TAT for the selected test
    const selectedTest = testList.find((t) => t.TestName === test.test); // Match by test name
    
    if (selectedTest) {
      setTat(selectedTest.tat); // Set the TAT value
     //  tat=selectedTest.tat
      console.log("tat for selected test is",selectedTest.tat )
      console.log("tat from useeffect is",tat)
     }
    const today = new Date();
    console.log("today is",today)
    today.setDate(today.getDate() + tat); // Add TAT to the sample received date

    console.log("test and tat is ",test.test,tat, today)
    return formatDateToYYYYMMDD(today);
  }
};
  const [expectedReportDate, setExpectedReportDate] = useState(() => {
    if (test.expectedReportDate) {
      console.log("expected date of report is uploaded ",test.expectedReportDate)
      return test.expectedReportDate;
    }
    console.log("Expected date of report is not found hence going inside calculateExpectedReportDateBasedonTAT")
    return calculateExpectedReportDateBasedonTAT();
  });
  console.log("expectedReportDate",expectedReportDate)

  useEffect(() => {
    setSampleReceivedStatus(test.sampleReceivedStatus || "Pending");
    setSampleReceivedDate(test?.sampleReceivedDate ?test.sampleReceivedDate: formatDateToYYYYMMDD(today));
    setRejectionReason(test.rejectionReason || "");
    // setSampleReceivedTime(test.sampleReceivedTime || "");
    setSampleReceivedTime(test?.sampleReceivedTime ?test.sampleReceivedTime: formatTimeToHHMM(today));
    setExpectedReportDate(test?.expectedReportDate?test.expectedReportDate:calculateExpectedReportDateBasedonTAT());
  }, [test]);
  console.log("expectedReportDateafter useeffect",expectedReportDate)
  const handleStatusChange = (e) => {
    setSampleReceivedStatus(e.target.value);
  };

  const handleDateChange = (e) => {
    setSampleReceivedDate(e.target.value);
  };

  const handleTimeChange = (e) => {
    setSampleReceivedTime(e.target.value);
  };
  const handleRejectionReasonChange = (e) => {
    setRejectionReason(e.target.value);
  };
  const handleExpecteReportDate = (e) => {
    setExpectedReportDate(e.target.value);
    console.log("e.target.value",e.target.value)
  };

  const handleSubmit = () => {

    if(sampleReceivedStatus==="Pending"){
      toast.error("Please Select Sample Recieved Status")
      return
    }
    if(sampleReceivedDate===""){toast.error("Please enter Sample Recieved Date") 
      return
    }
    if(sampleReceivedTime===""){toast.error("Please enter Sample Recieved Time")
       return}
    // if(expectedReportDate===""){toast.error("Please enter Expected Report date") 
    //   return}


    handleSampleReceivedStatus(test.id, {
      status: sampleReceivedStatus,
      date: sampleReceivedDate,
      time: sampleReceivedTime,
      expectedReportDate:expectedReportDate,
      rejectionReason:rejectionReason
    });
    console.log("handleSampleReceivedStatus",handleSampleReceivedStatus)
    // toast.success("Sample status updated successfully!");
    setTimeout(() => {
      onRequestClose();
    }, 1000);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content"
      overlayClassName="modal-overlay"
    >
      {/* <ToastContainer position="bottom-right" autoClose={5000} /> */}
      <h2>Sample Received Details</h2>
      <button className="close-button" onClick={onRequestClose}>×</button>
      <form className="modal-form">
       <div className="form-group">
          <label>Status:</label>
          <select value={sampleReceivedStatus} onChange={handleStatusChange} disabled={readOnly}>
            <option value="Pending">Pending</option>
            <option value="Received & Accepted">Received & Accepted</option>
            <option value="Received & Rejected">Received & Rejected</option>
          </select>
        </div>
        <div className="form-group">
          <label>Sample Received Date:</label>
          <input type="date" value={sampleReceivedDate} onChange={handleDateChange} disabled={readOnly} />
        </div>
        <div className="form-group">
          <label>Sample Received Time:</label>
          <input type="time" value={sampleReceivedTime} onChange={handleTimeChange} disabled={readOnly} />
        </div>
        
        {sampleReceivedStatus === "Received & Rejected" && (
          <div className="form-group">
            <label>Reason for Rejection:</label>
            <textarea value={rejectionReason} onChange={handleRejectionReasonChange} disabled={readOnly}></textarea>
            </div>
      )}
      {(sampleReceivedStatus === "Received & Accepted") && (
          <div className="form-group">
            <label>Expected Report date:</label>
            <input type="date"
             id="expectedReportDate" 
             value={expectedReportDate} 
             onChange={handleExpecteReportDate} 
             disabled={readOnly} />
            {/* <textarea value={expectedReportDate} onChange={handleExpecteReportDate} disabled={readOnly}></textarea> */}
            </div>
            
        )}
      </form>
      {!readOnly && <button className="submit-button" onClick={handleSubmit}>Submit</button>}
    </Modal>
  );
}

export default SampleModal;
